import React from 'react';
import { Cloud } from 'lucide-react';
import trustMeshBg from '../images/generated-v2/trust-mesh-bg.png';

export default function TrustBanner() {
  return (
    <section className="relative overflow-hidden bg-ink-950">
      <img src={trustMeshBg} className="absolute inset-0 w-full h-full object-cover opacity-70" alt="" aria-hidden="true" />
      <div className="absolute inset-0 bg-ink-950/40" />

      <div className="relative max-w-4xl mx-auto px-6 py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass mb-7">
          <Cloud size={14} strokeWidth={2.5} className="text-cyan-300" />
          <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-cyan-300">
            Backup automático en la nube
          </span>
        </div>
        <h2 className="text-4xl md:text-5xl font-bold tracking-tighter text-white mb-6 text-balance">
          Tu facturación, en todos tus<br />dispositivos. Siempre respaldada.
        </h2>
        <p className="text-lg text-white/65 leading-relaxed max-w-2xl mx-auto mb-10">
          Sincronización con <span className="text-white">iCloud</span> en iOS sin configurar nada.
          Respaldo en <span className="text-white">Google Drive</span> y <span className="text-white">Azure</span> en plan Pro.
          Si pierdes el celular, tu próxima factura sigue ahí.
        </p>

        {/* Trust pills */}
        <div className="flex flex-wrap items-center justify-center gap-2.5">
          {[
            { tag: 'iCloud', tone: 'sky' },
            { tag: 'Google Drive', tone: 'amber' },
            { tag: 'Azure', tone: 'cyan' },
            { tag: 'Multi-dispositivo', tone: 'violet' },
          ].map(({ tag }) => (
            <span key={tag} className="px-3.5 py-1.5 rounded-full glass text-white/85 text-[12px] font-medium">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
